/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { NdSysConfigCategoriesDto } from '../model/ndSysConfigCategoriesDto';
import { NdSysConfigDataTypeParam } from '../model/ndSysConfigDataTypeParam';
import { NdSysConfigDetailsDto } from '../model/ndSysConfigDetailsDto';
import { NdSysConfigMasterDto } from '../model/ndSysConfigMasterDto';
import { NdSysConfigValues } from '../model/ndSysConfigValues';
import { NdSysConfigValuesDto } from '../model/ndSysConfigValuesDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class NdSysConfigControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * findAllCategories
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAllCategoriesUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<NdSysConfigCategoriesDto>>;
    public findAllCategoriesUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NdSysConfigCategoriesDto>>>;
    public findAllCategoriesUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NdSysConfigCategoriesDto>>>;
    public findAllCategoriesUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<NdSysConfigCategoriesDto>>(`${this.basePath}/sysconfig/categories/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findAllConfigurations
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAllConfigurationsUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<NdSysConfigValuesDto>>;
    public findAllConfigurationsUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NdSysConfigValuesDto>>>;
    public findAllConfigurationsUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NdSysConfigValuesDto>>>;
    public findAllConfigurationsUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<NdSysConfigValuesDto>>(`${this.basePath}/sysconfig/configkeys/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findAllValues
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAllValuesUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<NdSysConfigValues>>;
    public findAllValuesUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NdSysConfigValues>>>;
    public findAllValuesUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NdSysConfigValues>>>;
    public findAllValuesUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<NdSysConfigValues>>(`${this.basePath}/sysconfig/values/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findByAllParam
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findByAllParamUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<NdSysConfigDataTypeParam>>;
    public findByAllParamUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NdSysConfigDataTypeParam>>>;
    public findByAllParamUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NdSysConfigDataTypeParam>>>;
    public findByAllParamUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<NdSysConfigDataTypeParam>>(`${this.basePath}/sysconfig/datatypeparam/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findByCategoryIdAndSubCategoryId
     * 
     * @param ndSysConfigMasterDto ndSysConfigMasterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findByCategoryIdAndSubCategoryIdUsingPOST(ndSysConfigMasterDto: NdSysConfigMasterDto, observe?: 'body', reportProgress?: boolean): Observable<Array<NdSysConfigMasterDto>>;
    public findByCategoryIdAndSubCategoryIdUsingPOST(ndSysConfigMasterDto: NdSysConfigMasterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NdSysConfigMasterDto>>>;
    public findByCategoryIdAndSubCategoryIdUsingPOST(ndSysConfigMasterDto: NdSysConfigMasterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NdSysConfigMasterDto>>>;
    public findByCategoryIdAndSubCategoryIdUsingPOST(ndSysConfigMasterDto: NdSysConfigMasterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ndSysConfigMasterDto === null || ndSysConfigMasterDto === undefined) {
            throw new Error('Required parameter ndSysConfigMasterDto was null or undefined when calling findByCategoryIdAndSubCategoryIdUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<NdSysConfigMasterDto>>(`${this.basePath}/sysconfig/configkeys`,
            ndSysConfigMasterDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findByConfigKey
     * 
     * @param configkey configkey
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findByConfigKeyUsingGET(configkey: string, observe?: 'body', reportProgress?: boolean): Observable<NdSysConfigDetailsDto>;
    public findByConfigKeyUsingGET(configkey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NdSysConfigDetailsDto>>;
    public findByConfigKeyUsingGET(configkey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NdSysConfigDetailsDto>>;
    public findByConfigKeyUsingGET(configkey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (configkey === null || configkey === undefined) {
            throw new Error('Required parameter configkey was null or undefined when calling findByConfigKeyUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NdSysConfigDetailsDto>(`${this.basePath}/sysconfig/configkeys/${encodeURIComponent(String(configkey))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findByParamId
     * 
     * @param parameterId parameterId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findByParamIdUsingGET(parameterId: string, observe?: 'body', reportProgress?: boolean): Observable<NdSysConfigDataTypeParam>;
    public findByParamIdUsingGET(parameterId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NdSysConfigDataTypeParam>>;
    public findByParamIdUsingGET(parameterId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NdSysConfigDataTypeParam>>;
    public findByParamIdUsingGET(parameterId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (parameterId === null || parameterId === undefined) {
            throw new Error('Required parameter parameterId was null or undefined when calling findByParamIdUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NdSysConfigDataTypeParam>(`${this.basePath}/sysconfig/datatypeparam/${encodeURIComponent(String(parameterId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findConfigCache
     * 
     * @param cacheKey cacheKey
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findConfigCacheUsingGET(cacheKey: string, observe?: 'body', reportProgress?: boolean): Observable<NdSysConfigValuesDto>;
    public findConfigCacheUsingGET(cacheKey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NdSysConfigValuesDto>>;
    public findConfigCacheUsingGET(cacheKey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NdSysConfigValuesDto>>;
    public findConfigCacheUsingGET(cacheKey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cacheKey === null || cacheKey === undefined) {
            throw new Error('Required parameter cacheKey was null or undefined when calling findConfigCacheUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NdSysConfigValuesDto>(`${this.basePath}/sysconfig/configkeys/configCache/${encodeURIComponent(String(cacheKey))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateConfigKey
     * 
     * @param ndSysConfigValues ndSysConfigValues
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateConfigKeyUsingPOST(ndSysConfigValues: NdSysConfigValuesDto, observe?: 'body', reportProgress?: boolean): Observable<NdSysConfigValuesDto>;
    public updateConfigKeyUsingPOST(ndSysConfigValues: NdSysConfigValuesDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NdSysConfigValuesDto>>;
    public updateConfigKeyUsingPOST(ndSysConfigValues: NdSysConfigValuesDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NdSysConfigValuesDto>>;
    public updateConfigKeyUsingPOST(ndSysConfigValues: NdSysConfigValuesDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ndSysConfigValues === null || ndSysConfigValues === undefined) {
            throw new Error('Required parameter ndSysConfigValues was null or undefined when calling updateConfigKeyUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<NdSysConfigValuesDto>(`${this.basePath}/sysconfig/configkeys/update`,
            ndSysConfigValues,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
